var render = function render(){var _vm=this,_c=_vm._self._c;return _c('List',{attrs:{"mcs-service-no":1}})
}
var staticRenderFns = []

export { render, staticRenderFns }